import React, { createContext, useContext, useEffect, useState } from "react";
import Keycloak from "keycloak-js";
import { KeycloakConfig } from "../model/Config";

type Kc = InstanceType<typeof Keycloak>;
type CtxT = { keycloak: Kc | null; initialized: boolean };
const C = createContext<CtxT>({ keycloak: null, initialized: false });
export function useKeycloak() {
  return useContext(C);
}
export function KeycloakProvider({ children }: { children: React.ReactNode }) {
  const [keycloak, setKc] = useState<Kc | null>(null);
  const [inited, setInited] = useState(false);
  useEffect(() => {
    const kc = new Keycloak(KeycloakConfig);
    (async () => {
      try {
        await kc.init({
          flow: "implicit" as const,
          checkLoginIframe: false,
          responseMode: "fragment" as const,
        });
        setKc(kc);
      } catch {
        setKc(kc);
      } finally {
        setInited(true);
      }
    })();
  }, []);
  return <C.Provider value={{ keycloak, initialized: inited }}>{children}</C.Provider>;
}
